











































import { computed, defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { UserAbuseReportType } from "@scrile/api-provider/dist/api/ReportsProvider";
import { Review } from "@scrile/api-provider/dist/api/ReviewProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { timeAgo } from "@/lib/time";
import { getProfileUrl } from "@/lib/urlHelpers";
import { resolveUserName } from "@/lib/userHelpers";
import { EVENTS, ROLES } from "@/const";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseAvatar from "@/components/BaseAvatar";
import BaseMenu from "@/components/BaseMenu";
import LinkifiedText from "@/components/LinkifiedText";
import config from "@/config";

export default defineComponent({
  name: "ReviewsItem",
  components: { BaseMenu, BaseIcon, BaseAvatar, LinkifiedText },
  props: {
    review: { type: Object as () => Review, required: true },
    canRemove: { type: Boolean, default: false },
    allowReply: { type: Boolean, default: true },
  },
  setup(props) {
    const profileUrl = computed<Location>(() => getProfileUrl(props.review.reviewerUser));
    const { authUser } = useAuthUser();

    const isReviewOwner = computed(() => {
      return props.review.reviewerId === authUser.value?.id;
    });
    const time = computed(() => {
      return timeAgo(props.review.time);
    });

    const isAllowExternalLinks = computed(() => {
      return (
        !!(props.review.reviewerUser as UserPublicData)?.verified ||
        checkRole(props.review.reviewerUser?.role || "", ROLES.ADMIN)
      );
    });

    const menuItems = computed(() => [
      {
        name: "report",
        text: $t("Report"),
      },
    ]);

    const onReport = () => {
      emitter.emit(EVENTS.OPEN_REPORT_MODAL, {
        subject: {
          subjectId: props.review.id,
          subjectType: UserAbuseReportType.REVIEW,
        },
        reportedUserId: props.review.reviewerId,
      });
    };

    return {
      config,
      isAllowExternalLinks,
      isReviewOwner,
      profileUrl,
      time,
      menuItems,
      onReport,
      resolveUserName,
    };
  },
});
